import { AxiosBookings, orgId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

export const consolidationsApiFactory = {
  $_getConsolidations(params) {
    const url = `/consolidation/org/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_searchConsolidations(params) {
    const url = `/consolidation/search/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },

  $_createConsolidation(payload) {
    const url = "/consolidation";
    return AxiosBookings.post(url, payload);
  },

  $_modifyConsolidation(consolidationId, payload) {
    const url = `/consolidation/${consolidationId}`;
    return AxiosBookings.patch(url, payload);
  },

  $_cancelConsolidation(consolidationId) {
    const url = `/consolidation/${orgId()}/${consolidationId}`;
    return AxiosBookings.delete(url);
  },

  $_viewManifest(fleetId) {
    const url = `/fleets/assigned/${fleetId}`;
    return AxiosBookings.get(url);
  },
  $_removeConsolidation(payload) {
    const url = `/consolidation/shipments/remove`;
    return AxiosBookings.patch(url, payload);
  },
  $_getConsolidation(id) {
    const url = `/consolidation/one/${id}`;
    return AxiosBookings.get(url);
  },

  $_getShippingServices() {
    const url = `/shippingservices/org/${orgId()}`;
    return AxiosBookings.get(url);
  },
  $_getConsolidationStatusList() {
    const url = "/consolidation/status-list";
    return AxiosBookings.get(url);
  },
};
